import { BasicInfo } from './basic-info/basic-info';
import { BudgetLimitTotal } from './budget/budget-limit-total';
import { Pretargeting } from './pretargeting/pretargeting';
import { Destination } from './destinations/destination';
import { Phases } from './phases/phases';
import { Targeting } from './targeting/targeting';
import styles from './campaign-form.module.scss';

import { KeysInTarget } from './sites-in-target/sites-in-target';
import { BidKeysAndSitesInfo } from './bidkeys-and-sites-info/bidkeys-and-sites-info';
import { CampaignRules } from './campaign-rules/campaign-rules';

export const CampaignForm = ({ isDuplicate }: { isDuplicate?: boolean }) => (
	<div className={styles.wrapper}>
		<BasicInfo />
		<Pretargeting />
		<Targeting isDuplicate={isDuplicate} />
		<Destination />
		<BudgetLimitTotal />
		<CampaignRules />
		<Phases />
		<BidKeysAndSitesInfo />
		<KeysInTarget />
	</div>
);
